module.exports = "/_next/static/images/nl-10d31cc2067a007b684d7869fb10ede5.svg";